import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private subject = new Subject<any>();
  private appSelectorSubject = new Subject<void>();

  constructor() { }

  openSideBar() {
    this.subject.next('open');
  }

  closeSideBar() {
    this.subject.next('close');
  }

  toggleAppSelector() {
    this.appSelectorSubject.next();
  }

  getHamburgerListener(): Observable<any> {
    return this.subject.asObservable();
  }

  appSelectorListener(): Observable<any> {
    return this.appSelectorSubject.asObservable();
  }
}
